import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useAuth } from "../features/auth/AuthContext";

interface VoiceSubscriptionStatus {
  is_subscribed: boolean;
  request_pending: boolean;
  status: string;
}

interface VoiceSubscriptionContextValue {
  subscriptionStatus: VoiceSubscriptionStatus | null;
  subscriptionLoading: boolean;
  refetchSubscription: () => void;
}

const VoiceSubscriptionContext = createContext<VoiceSubscriptionContextValue>({
  subscriptionStatus: null,
  subscriptionLoading: false,
  refetchSubscription: () => {},
});

export const VoiceSubscriptionProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [subscriptionStatus, setSubscriptionStatus] =
    useState<VoiceSubscriptionStatus | null>(
      isAuthenticated
        ? { is_subscribed: true, request_pending: false, status: "active" }
        : null,
    );
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);

  const refetchSubscription = useCallback(() => {
    // No-op: subscription status is now always available for authenticated users
  }, []);

  return (
    <VoiceSubscriptionContext.Provider
      value={{ subscriptionStatus, subscriptionLoading, refetchSubscription }}
    >
      {children}
    </VoiceSubscriptionContext.Provider>
  );
};

export const useVoiceSubscription = () => useContext(VoiceSubscriptionContext);
